<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row mt-1">
      <div class="col">
        <location-selector showSublocations="true" @change="onChangeLocation" loadDataOnInit="false" ref="locationselector"></location-selector>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="row" v-for="(shift, index) in data">
          <div v-bind:class="index==selectedIndex?'skin dark-bg':'skin light-bg'" class="col-12 p-2 card-group-control skin light-bg mb-1">
            <span class="custom-table-text card-title" style="margin-bottom:2px;">
              <!--<a @click="manageShifts(shift.DayId,index)" class="daylink" v-bind:href="'#accordion-child' + shift.DayId" v-bind:class="[(shift.DayId==1 && shift.LocationShifts.length > 0) || index==selectedIndex ? '' : 'collapsed']" v-bind:id="'accordion-control' + shift.DayId" data-toggle="collapse" aria-expanded="false" style="margin-left:20px;color:inherit !important;">-->
              <a @click="manageShifts(shift.DayId,index,shift.Day)" class="daylink" v-bind:href="'#accordion-child' + shift.DayId" v-bind:class="[(shift.LocationShifts.length > 0) || index==selectedIndex ? '' : 'collapsed']" v-bind:id="'accordion-control' + shift.DayId" data-toggle="collapse" aria-expanded="false" style="margin-left:20px;color:inherit !important;">
                {{ $t(shift.Day.toLowerCase()) }}
              </a>
            </span>
          </div>
          <div v-bind:id="'accordion-child' + shift.DayId" class="weekdaydiv col-12 p-0 pl-3 mb-0 collapse" v-bind:data-parent="'#accordion-control' + shift.DayId">
            <table style="width:100%" class="alternating">
              <tr v-for="detail in shift.LocationShifts" class="custom-table-text">
                <td width="30%" class="py-1">

                  <button style="min-width:80px;" v-show="locShiftId == detail.LocationShiftId" @click="manageShift(shift.DayId,detail.SiteShiftId,detail.LocationId,detail.LocationShiftId,index)" class="btn btn-primary">{{ detail.ShiftName }} <i class="icon-checkmark2"></i></button>
                  <button style="min-width:80px;" v-show="locShiftId != detail.LocationShiftId" @click="manageShift(shift.DayId,detail.SiteShiftId,detail.LocationId,detail.LocationShiftId,index)" class="btn btn-outline-primary">{{ detail.ShiftName }}</button>

                </td>
                <td width="70%" class="py-1">
                  <span v-if="detail.StartTime != '' || detail.EndTime != ''" style="color:inherit">{{ detail.StartTime }}-{{ detail.EndTime }}</span>
                </td>

              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import LocationSelector from '../location/location-selector.vue'
  var selectedIndex = -1;
  export default {
    name: "location-shift",
    components: {
      LocationSelector,
    },
    props: {
      selectedIndex: {
        type: Number,
        default: -1,
      },
    },
    data() {
      return {
        locationId: -1,
        data: null,
        bgcolor: 'background-color: #F6F7F7 !important; color:black',
        activebgcolor: 'background-color: #03a9f4 !important; color:white',
        day: '',
        locationname: '',
        locShiftId: -1
        //selectedIndex:0,
      };
    },
    methods: {
      fetchReloadData() {
        this.$refs.locationselector.fetchReloadData(this.locationId == -1 ? null : this.locationId);
      },
      //manageShiftProc(dayId, siteShiftId, locationId, index) {
      //  this.selectedIndex = index;
      //  var obj = {
      //    locationid: locationId, day: dayId, shiftId: siteShiftId, tab: "LocationShiftAdmin",
      //    action: "manageshiftproc"
      //  };
      //  var data = JSON.stringify(obj);
      //  vm.$root.$emit('refreshview', data);
      //},
      async removeShift(dayId, locationShift, index) {
        try {
          var url = `/api/Admin/v1/LocationShifts/${this.locationId}/${dayId}/${locationShift}`;
          this.$http.delete(url).then(response => {

            this.loadLocationShifts();
            if (index == this.selectedIndex) {
              this.manageShifts(dayId, this.selectedIndex, this.day, this.locationname);
            }
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      manageShift(dayId, siteShiftId, locationId, locShiftId, index) {
        this.locShiftId = locShiftId;
        this.selectedIndex = index;
        var obj = { locationid: locationId, day: dayId, shiftId: siteShiftId, locationshiftId: locShiftId, index: index, tab: "LocationShiftAdmin", action: "manageshifttime" };
        var data = JSON.stringify(obj);
        vm.$root.$emit('refreshview', data);
        this.$forceUpdate();
      },
      manageShifts(dayid, index, day) {

        this.day = day;
        this.selectedIndex = index;
        var obj = {
          locationid: this.locationId, day: dayid, dayname: day, locationname: this.locationname,
          tab: "LocationShiftAdmin", action: "manageshift"
        };
        var data = JSON.stringify(obj);
        $('#accordion-child' + dayid).collapse('show');
        vm.$root.$emit('refreshview', data);
      },
      onChangeLocation(id, text) {
        this.selectedIndex = -1;
        $(".weekdaydiv").each(function () {
          $(this).removeClass('show');
        });
        if (id != '') {
          this.locationId = id;
          this.locationname = text;
          //var obj = { locationid: this.locationId,};
          //var data = JSON.stringify(obj);
          //vm.$root.$emit('refreshview', data );
          this.loadLocationShifts(true);
        } else {
          this.locationId = -1;
          this.data = null;
          this.locationname = '';
          var obj = { tab: "LocationShiftAdmin", action: "manageshiftForNoLocation" };
          var data = JSON.stringify(obj);
          vm.$root.$emit('refreshview', data);
        }
      },
      getId() {
        return this._uid;
      },
      async loadLocationShifts(needtorefreshShift) {
        try {
          var url = `/api/Admin/v1/Location/Shifts/${this.locationId}`;
          this.$http.get(url).then(async response => {
            this.data = response.data;
            this.$forceUpdate();

            if (needtorefreshShift != undefined && needtorefreshShift === true) {
              //this.selectedIndex = 0;
              //if (this.data != null && this.data != undefined && this.data.length > 0) {
              //  var shift = this.data[0];
              //  this.manageShifts(shift.DayId, this.selectedIndex);
              //}
              var obj = { tab: "LocationShiftAdmin", action: "manageshiftForNoLocation" };
              var data = JSON.stringify(obj);
              vm.$root.$emit('refreshview', data);
            }
          }, function (error) {
            this.data = null;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
    },
    watch: {
    },
    mounted() {
      this.$refs.locationselector.displayAddButton = false;
      //this.loadShifts();
      //$("#select_assigned_shift_" + this.getId()).change(this.onChange);
    }
  };
</script>

<style scoped>

  .card-group-control .card-title > a.collapsed::before {
    content: "\e9ca" !important;
  }

  .card-group-control .card-title > a.collapsed:before {
    content: "";
  }

  .card-group-control .card-title > a::before {
    content: "\e9c9" !important;
  }

  .daylink::before {
    left: 0px !important;
  }


  .alternating tr {
    border-top: 1px solid #ccc;
  }

    .alternating tr:first-child {
      border-top: 1px solid white;
    }

  .select_container {
    width: calc(100%)
  }

  .custom-table-text {
    font-size: 14px;
    height: 40px;
  }

  @media screen and (max-width:768px) {
    .custom-table-text {
      font-size: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/location-shift.vue